<template lang="">
    <div class="formWrite">
        <FormQuestionList />
    </div>
</template>

<script>
import FormQuestionList from '../../components/Web/FormQuestion/FormQuestionList.vue';

export default {
    components: {
        FormQuestionList,
    },
};
</script>

<style lang="scss">
.formWrite {
    width: 100%;
    max-width: 1170px;
    padding: 0 15px;
    margin: 40px auto;
}
</style>
